import { NavLink } from "react-router-dom";
import { cn } from "@/lib/cn";

const items = [
  { to: "/app/admin", label: "Overview", end: true },
  { to: "/app/admin/sources", label: "Sources", end: false },
  { to: "/app/admin/synthesis", label: "Synthesis", end: false },
  { to: "/app/admin/opportunities", label: "Opportunities", end: false },
  { to: "/app/admin/circles", label: "Circles", end: false },
];

/**
 * Sub-nav for admin pages. Monochrome typography, no pills — a thin
 * underline marks the active section.
 */
export function AdminNav() {
  return (
    <nav className="flex items-center gap-6 border-b border-veil/40 mb-10">
      {items.map(({ to, label, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            cn(
              "py-3 text-xs uppercase tracking-[0.18em] transition-colors -mb-px border-b",
              isActive
                ? "text-fog border-gold-glow"
                : "text-whisper hover:text-fog border-transparent",
            )
          }
        >
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
